import Component from 'vue-class-component';
import { Prop, Vue, Watch } from 'vue-property-decorator';
import cloneDeep from 'lodash/cloneDeep';
import { sum } from 'lodash';
import BatchSetup from '@/views/components/batchSetup/batch.vue';
import { toDecimal2 } from '@/util';
import { defaultImg } from '@/views/components/newDisplayConfig/shop';

/**
 *
 * 显示商品组件的配置
 *
 * 2020.06.12 update 改为数组形式，可自定多个字段
 */
export const productItemConfig: { [keys in string]: { text: string; key: string }[] } = {
  seckill: [
    {
      key: 'price',
      text: '秒杀价',
    },
  ],
  group: [
    {
      key: 'outGroupPrice',
      text: '单买价',
    },
    {
      key: 'groupPrice',
      text: '拼团价',
    },
  ],
};

@Component({
  components: {
    BatchSetup,
  },
})
export default class ProductItem extends Vue {
  @Prop()
  goodsList: any[];

  @Prop({ default: true })
  editState: boolean;

  @Prop()
  columnKey: string;

  @Prop()
  configKey: string;

  // 类型，是按货号还是按版单号 1|2
  @Prop({ default: 1 })
  type: 1 | 2;

  // 该商品最大购买数
  public maxSaleNum = 0;

  // 编辑库存的权限
  @Prop({ default: false })
  editStockState: boolean;

  // 是否为秒杀组
  @Prop({ default: false })
  isSeckillGroup: boolean;

  // 秒杀组id
  @Prop({ default: '' })
  skgId: string;

  @Prop({ default: 0 })
  isCopy: number

  @Watch('goodsList', { immediate: true })
  onGoodsListChange(n, o) {
    if (n && JSON.stringify(n) !== JSON.stringify(o)) {
      this.goodsListCopy = this.goodsList.map((i) => {
        if (this.type === 1) {
          return this.dateSet(i);
        } else {
          i.brProducts = i.brProducts.map((v) => {
            return this.dateSet(v);
          });
          return i;
        }
      });
    }
  }

  // 数据的处理
  public dateSet(v) {
    this.$set(v, '_edit', false);
    // 最多购买的checkbox
    if (v.maxBuyerNum === 0) {
      delete v.maxBuyerNum;
    }
    if (v.minBuyerNum === 0 && this.isSeckillGroup) {
      delete v.minBuyerNum;
    }
    if (v.maxBuyerNum || v.minBuyerNum) {
      this.$set(v, '_limitBuyer', true);
    } else {
      this.$set(v, '_limitBuyer', false);
    }

    this.$set(v, 'isOpenCommission', !!v.isOpenCommission);
    // this.$set(v, this.config.key, 0);

    // 展开收起
    this.$set(v, '_isZK', true);

    // 最多购买的checkbox

    if (this.isSeckillGroup) {
      // 是否是必选商品
      if (!v.isMustBuy) {
        this.$set(v, 'isMustBuy', 0);
      }
      this.$set(v, '_isMustBuy', !!v.isMustBuy);
      // 是否是默认选中
      if (!v.isDefault) {
        this.$set(v, 'isDefault', 0);
      }
      this.$set(v, '_isDefault', !!v.isDefault);
    }

    // 判断自定义字段，没有就赋值为0
    v.skuItems.map((z) => {
      // 库存
      if (!z.stock) {
        this.$set(z, 'stock', 0);
      }
      this.config.forEach((conf) => {
        if (!z.hasOwnProperty(conf.key)) {
          this.$set(z, conf.key, v.originPrice || z.originPrice);
        }
      });
    });
    return v;
  }

  defaultImg = defaultImg;
  // 复制的参数
  goodsListCopy = [];

  // 编辑单项商品的复制
  itemCopy = null;
  // @ts-expect-error
  config = productItemConfig[this.configKey];

  getValuePriceSection(item, key) {
    let priceObject = '';
    const price = item.skuItems.map((i) => {
      return +i[key];
    });
    const max = toDecimal2(Math.max.apply(Math, price)) || '';
    const min = toDecimal2(Math.min.apply(Math, price)) || '';
    priceObject = max === min ? `￥${max}` : `￥${min} ~ ` + `￥${max}`;

    return priceObject;
  }

  getLiveRoomPrice(item, key) {
    return this.getValuePriceSection(item, key);
  }

  getBageRoomPrice(item) {
    return this.getValuePriceSection(item, 'originPrice');
  }

  getSaleAndSurplus(row) {
    if (this.isCopy) {
      return `0/${(row.stock || 0)}`;
    }
    return `${row.saleNum || 0}/${(row.stock || 0) - (row.saleNum || 0)}`;
  }

  onMaxBuyChange(item) {
    if (!item._limitBuyer) {
     delete item.maxBuyerNum ;
    }else{
      if(this.isSeckillGroup){
        item.minBuyerNum = 1;
      } 
    }
  }

  onOpenCommission(item) {
    console.log(item);
  }

  changeMustBuy(item) {
    item.isMustBuy = item._isMustBuy ? 1 : 0;
    if (item._isMustBuy) {
      this.$set(item, '_isDefault', true);
      this.$set(item, 'isDefault', 1);
    } else {
      this.$set(item, '_isDefault', false);
      this.$set(item, 'isDefault', 0);
    }
  }

  onDefaultChange(item) {
    item.isDefault = item._isDefault ? 1 : 0;
  }

  //  商品列表的编辑
  handleEditGood(item) {
    this.itemCopy = cloneDeep(item);
    const saleNumList = item.skuItems.map(el => el.saleNum);
    this.maxSaleNum = Math.max(...saleNumList);
    item._edit = true;
  }

  handleEditGoodEvent(index, ind?) {
    if (ind !== undefined && ind !== null) {
      this.goodsListCopy[ind].brProducts[index]._edit = false;
    } else {
      this.goodsListCopy[index]._edit = false;
    }
    if (this.isSeckillGroup) {
      if (this.goodsListCopy[index].maxBuyerNum >= this.goodsListCopy[index].minBuyerNum) {
        this.$emit('update:goodsList', this.goodsListCopy);
      }
      if (this.skgId !== '0') {
        // 秒杀组编辑实时保存
        this.$emit('editProduct', this.goodsListCopy[index]);
      }
    } else {
      this.$emit('update:goodsList', this.goodsListCopy);
    }
  }

  /**
   *
   * @param index
   * @param type
   * @param val
   * @param ind
   */
  handleEditGoodsConfirm(index, type, val, ind) {
    if (val === 0) {
      this.$message.error(`${type === 'stock' ? '库存' : '价格'}不可设为0`);
      return;
    }
    if (ind !== undefined && ind !== null) {
      this.goodsListCopy[ind].brProducts[index].skuItems.map((i) => {
        i[type] = val;
        return i;
      });
      const tv = cloneDeep(this.goodsListCopy[ind].brProducts[index]);
      tv._edit = false;
      this.itemCopy = tv;
    } else {
      this.goodsListCopy[index].skuItems.map((i) => {
        i[type] = val;
        return i;
      });
      const tv = cloneDeep(this.goodsListCopy[index]);
      tv._edit = false;
      this.itemCopy = tv;
    }
    this.$emit('update:goodsList', this.goodsListCopy);
    if (this.isSeckillGroup && this.skgId !== '0') {
      // 秒杀组编辑实时保存
      this.handleEditGoodEvent(index, ind);
    }
  }

  handleEditGoodsCancel(index) {
    // TODO
  }

  /**
   * 商品类别取消
   * @param index
   */
  handleEditGoodCancel(index) {
    this.$confirm('确认取消保存吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then((res) => {
        if (res === 'confirm') {
          this.$set(this.goodsListCopy, index, this.itemCopy);
          if (this.isSeckillGroup) {
            this.$emit('update:goodsList', this.goodsListCopy);
          }
        }
      })
      .catch((err) => { });
  }
  key = 0
  changeStock(val) {
    this.key = Math.random()
  }
  getSummaries(param) {
    const { columns, data } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = '合计';
        return;
      }
      const values = data.map(item => Number(item[column.property]));
      if (!values.every(value => Number.isNaN(value))) {
        // TODO 后期需优化只只算单独的值，而不是全部计算
        sums[index]
          = values
            .map(i => i * 100)
            .reduce((prev, curr) => {
              const value = Number.parseInt(`${Number(curr)}`);
              if (!Number.isNaN(value)) {
                return Number.parseInt(`${Number(prev)}`) + Number.parseInt(`${Number(curr)}`);
              } else {
                return Number.parseInt(`${Number(prev)}`);
              }
            }, 0) / 100;

        if (index !== columns.length - 2) {
          sums[index] = '-';
        }
      } else {
        sums[index] = '-';
      }
    });
    return sums;
  }

  /**
   * 上移或下移
   */
  changeSort(type, index) {
    switch (type) {
      case 'up':
        if (index != 0) {
          this.goodsListCopy[index] = this.goodsListCopy.splice(index - 1, 1, this.goodsListCopy[index])[0];
        } else {
          this.goodsListCopy.push(this.goodsListCopy.shift());
        }
        break;
      case 'down':
        if (index != this.goodsListCopy.length - 1) {
          this.goodsListCopy[index] = this.goodsListCopy.splice(index + 1, 1, this.goodsListCopy[index])[0];
        } else {
          this.goodsListCopy.unshift(this.goodsListCopy.splice(index, 1)[0]);
        }
        break;
    }
    this.$emit('update:goodsList', this.goodsListCopy);
  }

  changeMin(item) {
    if (item.minBuyerNum === 0) {
      this.$message.error('最小购买数不可设为0');
      item.minBuyerNum = 1;
    }
    if (!item.minBuyerNum && !item.maxBuyerNum) {
      this.$message.error('请至少填写一个');
      item.minBuyerNum = 1;
    }
    if (item.minBuyerNum > item.maxBuyerNum) {
      this.$message.error('最小购买数不能大于最大购买数');
      item.minBuyerNum = 1;
    }
  }

  changeMax(item) {
    if (this.isSeckillGroup) {
      if (item.maxBuyerNum === 0) {
        this.$message.error('最大购买数不可设为0');
        item.maxBuyerNum = 1;
      }
      if (!item.minBuyerNum && !item.maxBuyerNum) {
        this.$message.error('请至少填写一个');
        item.maxBuyerNum = 1;
      }
      if (item.minBuyerNum > item.maxBuyerNum) {
        this.$message.error('最大购买数不能小于最小购买数');
        item.maxBuyerNum = item.minBuyerNum;
      }
    }
  }

  /**
   *  删除
   */
  delItem(index) {
    const text = this.skgId === '0' ? '是否确认删除？' : '删除后将实时生效，无需重新发布，是否确认删除?';
    this.$confirm(text, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then((res) => {
        if (res === 'confirm') {
          if (this.skgId !== '0') {
            this.$emit('delProduct', this.goodsListCopy[index]);
          }
          this.goodsListCopy.splice(index, 1);
          this.$emit('update:goodsList', this.goodsListCopy);
        }
      })
      .catch((err) => { });
  }
}
